<template>
    <div>
        <el-dialog :visible.sync="showDigitalVoucherRent" :center="true" :width="widthModal()" :height="heightModal()"
            :style="{ marginTop: marginTopModal() }" @close="closeModalRentVariable">
            <div class=" justify-content-center flex-column text-center text-bat popups-variable-rent"
                style="word-break: normal">
                <div>
                    <div>
                        <div class="d-flex justify-content-between header">
                            <div class="header">
                                <h5 class="mb-3 text-start text-title-bat">Variables aceleradoras</h5>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2">
                        <div class="d-flex flex-column text-start">
                            <div>
                                <img src="/img-version2/icons/cohete-verde.svg" alt="">
                                <span><strong>Cohete:</strong> Gana hasta el
                                    <strong>{{ accelerators[0].value }}%.</strong></span>
                            </div>
                            <hr>
                            <div>
                                <img src="/img-version2/icons/meteorito-verde.svg" alt="">
                                <span><strong>Meteorito:</strong> Gana hasta el
                                    <strong>{{ accelerators[1].value }}%.</strong></span>
                            </div>
                            <hr>
                        </div>
                    </div>

                    <div>
                        <div class="row">
                            <div class="col text-bat">
                                <h6 class="mb-3 text-start text-title-bat">Estados de cumplimiento de objetivos
                                </h6>
                                <div class="d-flex">
                                    <div class="vertical-line">
                                        <span class="traffic-light tag-initial"></span>
                                        <span>0% hasta < 90%</span>
                                    </div>
                                    <div class="vertical-line">
                                        <span class="traffic-light tag-average"></span>
                                        <span>90% hasta < 100%</span>
                                    </div>
                                    <div>
                                        <span class="traffic-light tag-high"></span>
                                        <span>100%</span>
                                    </div>
                                </div>
                                <h6 class="mb-3 mt-3 text-start text-bat">Si la varibale es aceleradora, ten en cuenta que:
                                </h6>
                                <div class="row">
                                <div class="col-6 mb-2">
                                    <img src="/img-version2/icons/cohete-verde.svg" alt="">
                                    <span class="traffic-light tag-high"></span>
                                    <span>100% hasta < {{ accelerators[0].value }}%</span>
                                </div>
                                <div class="col">
                                    <img src="/img-version2/icons/cohete-azul.svg" alt="">
                                    <span class="traffic-light tag-super"></span>
                                    <span>{{ accelerators[0].value }}%</span>
                                </div>
                                <div class="col-6">
                                    <img src="/img-version2/icons/meteorito-verde.svg" alt="">
                                    <span class="traffic-light tag-high"></span>
                                    <span>100% hasta < {{ accelerators[1].value }}%</span>
                                </div>
                                <div class="col">
                                    <img src="/img-version2/icons/meteorito-morado.svg" alt="">
                                    <span class="traffic-light tag-super-top "></span>
                                    <span>{{ accelerators[1].value }}%</span>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    components: {

    },
    props: {
        url_media: {
            default: '',
        },
        accelerators: {
            default: null,
        },
        closeModalRentVariable: Function
    },
    data() {
        return {
            showDigitalVoucherRent: true,
        }
    },
    mounted() {

    },
    created() {

    },
    methods: {


        widthModal() {
            let width = '100% !important';
            if (this.$mq === 'md') {
                width = '80% !important';
            } else if (this.$mq === 'lg') {
                width = '90% !important';
            } else if (this.$mq === 'xl') {
                width = '95%';
            }
            return width;
        },
        heightModal() {
            let height = 'auto';
            if (this.$mq === 'md') {
                height = '80vh';
            } else if (this.$mq === 'lg') {
                height = '90vh';
            } else if (this.$mq === 'xl') {
                height = '95vh';
            }
            return height;
        },
        marginTopModal() {
            return '0vh ';
        }
    },
}
</script>
